<template>
  <v-card>
    <v-card-text>
      <v-window v-model="tab">
        <v-window-item value="one">
          <v-card>
            <v-tabs
              v-model="active_tab"
              background-color="primary"
              hide-slider
              optional
              color="primary"
            >
              <v-tab
                v-for="n in template"
                :key="n"
                :value="n"
                @click="openTemplate(n)"
              >
                {{ n.title }}
              </v-tab>
              <v-tab @click="templateCreate">
                <v-icon dark color="blue"> mdi-plus </v-icon></v-tab
              >
            </v-tabs>
          </v-card>
        </v-window-item>
      </v-window>
    </v-card-text>
    <v-col
      cols="12"
      sm="12"
      md="12"
      lg="6"
      class="pl-8"
      v-if="this.templatetype == 'Sale'"
    >
      <v-alert border="left" colored-border color="deep-purple" elevation="2">
        <div class="text-h6">Use this tag for sales</div>
        {total},{paid_amount},{date},{reference_number},{shop_name},{biller_name}
      </v-alert>
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="12"
      lg="3"
      class="pl-8"
      v-if="this.templatetype != 'Sale'"
    >
      <v-text-field
        outlined
        color="primary"
        label="Template Title"
        v-model="templatename"
        required
      ></v-text-field>
    </v-col>

    <v-col cols="12" sm="12" md="12" lg="6" class="pl-8">
      <v-form>
        <v-textarea
          v-model="templatebody"
          label="Message"
          hide-details="auto"
          dense
          outlined
          counter
        >
        </v-textarea>
      </v-form>
      <v-col cols="12" class="text-right pa-0" v-if="newTemplateOpen">
        <v-btn
          depressed
          small
          class="ml-1 text-white btn_medium"
          color="primary"
          @click="submitTemplate"
          >Save</v-btn
        >
      </v-col>
      <v-col cols="12" class="text-right pa-0" v-if="!newTemplateOpen">
        <v-btn
          depressed
          small
          class="ml-1 text-white btn_medium"
          color="primary"
          @click="updateTemplate"
          >Update</v-btn
        >
      </v-col>
    </v-col>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    template: [],
    tags: ['New year', 'Pongal', 'Christmas', 'Anniversary'],
    selectedTags: [],
    messages: '',
    templatebody: '',
    templatename: '',
    templatetype: 'Sale',
    newTemplateOpen: false,
    isLoading: true,
    messages: '',
    templateid: '',
    active_tab: 1,
  }),

  computed: {},

  created() {
    this.getTemplate();
  },

  methods: {
    openTemplate(item) {
      this.templatebody = item.body;
      this.templatename = item.title;
      this.templatetype = item.type;
      this.templateid = item.id;
      this.newTemplateOpen = false;
    },
    getTemplate() {
      this.shopLoading = true;
      this.$store
        .dispatch('sms/GetSMSTempate')
        .then((res) => {
          this.template = res.data.data;
          this.openTemplate(this.template[0]);
        })
        .catch((err) => {
          this.messages = err.data.name;
        });
    },
    templateCreate() {
      this.newTemplateOpen = true;
      this.templatebody = '';
      this.templatename = '';
      this.templatetype = '';
    },

    submitTemplate() {
      let tempData = {
        title: this.templatename,
        body: this.templatebody,
      };
      this.isLoading = true;

      this.$store
        .dispatch('sms/CreateTempleate', tempData)
        .then((res) => {
          this.$toast.success('SMS Template created successfully');
          this.isLoading = false;
          this.templatebody = '';
          this.templatename = '';
          window.location.reload();
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
          this.$toast.error('Failed to create SMS template');
          this.messages = err.data.title;
          this.isLoading = false;
        });
    },
    updateTemplate() {
      let tempData = {
        id: this.templateid,
        title: this.templatename,
        body: this.templatebody,
      };
      this.isLoading = true;

      this.$store
        .dispatch('sms/UpdateTempleate', tempData)
        .then((res) => {
          this.$toast.success('SMS template updated successfully');
          window.location.reload();
          this.isLoading = false;
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
          this.$toast.error('Failed to update SMS template.');
          this.messages = err.data.title;
          this.isLoading = false;
        });
    },
  },
};
</script>
